import React, { Component } from "react";
import NumberFormat from "react-number-format";
import html2canvas from "@html2canvas/html2canvas";
import { APIURL, PORT } from "../../../config/config";
import axios from "axios";
import { NumberUtil } from "../../../utils/number-util";
// import {getDocTypeConfig} from "../../../services/companysetting";

export default class CarDownSchedule extends Component {
  constructor(props) {
    super(props);
    this.printRef = React.createRef();
    //this.handleOnSubmitCustomer.bind(this);
    this.state = {
      lists: [],
      load_data: true,
      danger: false,
      car_id: 0,
      action: "บันทึก",
      car: this.props.car,
      company_setting: null,
      carBase64Img: "",
      logoBase64Img: "",
      carDownPercent: [],
      car_down_note: [],
      is_download: false,
      car_down_schedule_note: "",
      is_show_percent_down: PORT === 9070 ? false : true,
      is_submitting: false,
      // เพิ่มสำหรับ interest_by_period
      interest_type: PORT === 9079 ? "by_period" : "by_down",
      interest_by_period: [],
      interest_48: null,
      interest_60: null,
      interest_72: null,
      interest_84: null,
      interest_96: null,
    };

    this.togglePreviewImage = this.togglePreviewImage.bind(this);
    this.onPreviewSelected = this.onPreviewSelected.bind(this);
    this.handleDownloadImage = this.handleDownloadImage.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCompanyLogoBase64 = this.loadCompanyLogoBase64.bind(this);
    this.loadCarImageBase64 = this.loadCarImageBase64.bind(this);
    this.onChangeInputCarDownInterest =
      this.onChangeInputCarDownInterest.bind(this);
    this.calCarDownSchedule = this.calCarDownSchedule.bind(this);
    this.calInstallationMonth = this.calInstallationMonth.bind(this);
    this.calculateDownPercent = this.calculateDownPercent.bind(this);
    this.getCarLeasingPrice = this.getCarLeasingPrice.bind(this);
    this.onChangeInputCarDownPrice = this.onChangeInputCarDownPrice.bind(this);
    //this.handleChangeInput = this.handleChangeInput.bind(this);
    //this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount() {
    this.mounted = true;

    this.loadCompanyLogoBase64();
    this.loadCompanySetting();
    //this.loadCarDownPercent();
    this.loadCarDownSchedule();
    this.loadCarImageBase64();

    this.setState({ car_sale_price: this.state.car.car_sale_price });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  loadCarDownPercent() {
    let url = APIURL + "/car_down_percent/";
    axios.get(url).then((res) => {
      if (this.mounted) {
        this.setState({ carDownPercent: res.data });
      }
    });
  }

  // คำนวยยอดจัด
  calInstallationMonth(car_leasing_price, interest, year) {
    // D6 = car_leasing_price
    let periodMonth = year * 12;
    let D6 = car_leasing_price;
    let C6 = interest / 100;
    let vat = 7 / 100;
    if (PORT === 9070) {
      vat = 0;
    }
    let monthly_installment_real = (D6 * C6 * year + D6) / periodMonth;
    let monthly_installment_vat = monthly_installment_real * vat;
    // =((D6*C6*4+D6)/48*7%)+(D6*C6*4+D6)/48
    let monthly_installment =
      monthly_installment_real + monthly_installment_vat;
    return parseFloat(String(monthly_installment)).toFixed(2);
  }

  // คำนวณ % ดาวน์จากยอดเงินดาวน์
  calculateDownPercent(downPrice, carSalePrice) {
    if (!downPrice || !carSalePrice || carSalePrice === 0) {
      return "0.00";
    }
    // Remove comma from value if exists
    let price =
      typeof downPrice === "string"
        ? NumberUtil.removeComma(downPrice)
        : downPrice;
    let salePrice =
      typeof carSalePrice === "string"
        ? NumberUtil.removeComma(carSalePrice)
        : carSalePrice;

    let percent = (price / salePrice) * 100;
    return parseFloat(String(percent)).toFixed(2);
  }

  loadCarDownSchedule() {
    let car_id = this.props.car.car_id;
    let username = this.props.username;
    //let car_down_schedule_note =this.props.car.car_down_schedule_note
    let uri = APIURL + "/car_down_schedule/" + car_id;
    axios
      .get(uri)
      .then((res) => {
        if (this.mounted) {
          let data = res.data;
          let car_down_schedule_new = [];

          let car_down_schedule_note = data.car_down_schedule_note;

          // ดึง interest_by_period และ interest_type (ย้ายมาตรงนี้เพื่อใช้ตรวจสอบก่อนสร้าง custom row)
          let interest_by_period = data.interest_by_period || [];
          let interest_type = data.interest_type || "by_down";

          if (data.car_down_schedule.length === 0) {
            //กรณียังไม่บันทึก
            let car_down_percents = data.car_down_percent;

            // กรองข้อมูลซ้ำตาม car_down_percent_id
            let uniquePercents = [];
            let seenIds = new Set();

            for (let i = 0; i < car_down_percents.length; i++) {
              let percent = car_down_percents[i];
              if (!seenIds.has(percent.car_down_percent_id)) {
                seenIds.add(percent.car_down_percent_id);
                uniquePercents.push(percent);
              }
            }

            for (let i = 0; i < uniquePercents.length; i++) {
              let car_down_percent = uniquePercents[i];

              let down_schedule_empty = {
                car_id: car_id,
                car_down_percent_name: car_down_percent.car_down_percent_name,
                car_down_percent_id: car_down_percent.car_down_percent_id,
                car_down_interest: car_down_percent.car_down_interest,
                car_down_schedule_id: i + 1,
                car_down_schedule_price: "",
                monthly_installment_48: "",
                monthly_installment_60: "",
                monthly_installment_72: "",
                monthly_installment_84: "",
                monthly_installment_96: "",
                user_created: username,
                status_text: "new",
                is_custom_row: false,
              };
              let down_schedules =
                PORT === 9061 || PORT === 9039
                  ? down_schedule_empty
                  : this.calCarDownSchedule(down_schedule_empty);
              car_down_schedule_new.push(down_schedules);
            }

            // เพิ่มแถว "กำหนดเอง" หลังจาก preset rows ทั้งหมด (เฉพาะกรณี interest_type === "by_down")
            if (interest_type !== "by_period") {
              let custom_row = {
                car_id: car_id,
                car_down_percent_name: "กำหนดเอง",
                car_down_percent_id: 0,
                car_down_interest: "",
                car_down_schedule_id: "custom",
                car_down_schedule_price: "",
                monthly_installment_48: "",
                monthly_installment_60: "",
                monthly_installment_72: "",
                monthly_installment_84: "",
                monthly_installment_96: "",
                user_created: username,
                status_text: "new",
                is_custom_row: true,
              };
              car_down_schedule_new.push(custom_row);
            }
          } else {
            let car_down_schedules = data.car_down_schedule;
            let car_sale_price = this.props.car.car_sale_price;
            for (let i = 0; i < car_down_schedules.length; i++) {
              let car_down_schedule = car_down_schedules[i];
              let car_id = car_down_schedule.car_id;
              let car_down_percent_name =
                car_down_schedule.car_down_percent_name;
              let car_down_percent_id = car_down_schedule.car_down_percent_id;
              let car_down_schedule_id = car_down_schedule.car_down_schedule_id;

              let car_down_schedule_price =
                car_down_schedule.car_down_schedule_price;
              let car_down_interest = car_down_schedule.car_down_interest;

              let monthly_installment_48 =
                car_down_schedule.monthly_installment_48;
              let monthly_installment_60 =
                car_down_schedule.monthly_installment_60;
              let monthly_installment_72 =
                car_down_schedule.monthly_installment_72;
              let monthly_installment_84 =
                car_down_schedule.monthly_installment_84;
              let monthly_installment_96 =
                car_down_schedule.monthly_installment_96;

              let interest_48 = car_down_schedule.interest_48;
              let interest_60 = car_down_schedule.interest_60;
              let interest_72 = car_down_schedule.interest_72;
              let interest_84 = car_down_schedule.interest_84;
              let interest_96 = car_down_schedule.interest_96;

              let is_custom_row =
                car_down_percent_id == 0 || car_down_percent_id === null;

              // สำหรับ custom row (car_down_percent_id === 0) ใน edit mode
              if (is_custom_row) {
                // ถ้ามีค่าเงินดาวน์ ให้คำนวณ % ย้อนกลับ
                if (
                  car_down_schedule_price &&
                  Number(car_down_schedule_price) > 0 &&
                  car_sale_price
                ) {
                  let calculated_percent = this.calculateDownPercent(
                    car_down_schedule_price,
                    car_sale_price,
                  );
                  car_down_percent_name = calculated_percent + "%";
                } else {
                  // ถ้าไม่มีค่าเงินดาวน์ ให้แสดง "กำหนดเอง"
                  car_down_percent_name = "กำหนดเอง";
                }
              }

              let down_schedule_new = {
                car_id: car_id,
                car_down_percent_name: car_down_percent_name,
                car_down_percent_id: car_down_percent_id,
                car_down_schedule_id: car_down_schedule_id,
                car_down_schedule_price: car_down_schedule_price,
                car_down_interest: car_down_interest,
                interest_48: interest_48,
                interest_60: interest_60,
                interest_72: interest_72,
                interest_84: interest_84,
                interest_96: interest_96,
                interest_type: car_down_schedule.interest_type,
                monthly_installment_48: monthly_installment_48,
                monthly_installment_60: monthly_installment_60,
                monthly_installment_72: monthly_installment_72,
                monthly_installment_84: monthly_installment_84,
                monthly_installment_96: monthly_installment_96,
                user_created: username,
                status_text: "exits",
                is_custom_row: is_custom_row,
              };

              // Call calCarDownSchedule for custom rows to ensure proper formatting
              let down_schedule_processed = is_custom_row
                ? this.calCarDownSchedule(down_schedule_new)
                : down_schedule_new;
              car_down_schedule_new.push(down_schedule_processed);
            }

            // เพิ่มแถว "กำหนดเอง" ถ้ายังไม่มีในข้อมูลที่โหลดมา (เฉพาะกรณี interest_type === "by_down")
            // ตรวจสอบทั้งกรณี car_down_percent_id === 0, null หรือ car_down_percent_name === ""
            let has_custom_row = car_down_schedules.some(
              (item) =>
                item.car_down_percent_id === 0 ||
                item.car_down_percent_id === null ||
                item.car_down_percent_name === "",
            );
            if (!has_custom_row && interest_type !== "by_period") {
              let custom_row = {
                car_id: car_id,
                car_down_percent_name: "กำหนดเอง",
                car_down_percent_id: 0,
                car_down_interest: "",
                car_down_schedule_id: "custom",
                car_down_schedule_price: "",
                monthly_installment_48: "",
                monthly_installment_60: "",
                monthly_installment_72: "",
                monthly_installment_84: "",
                monthly_installment_96: "",
                user_created: username,
                status_text: "new",
                is_custom_row: true,
              };
              car_down_schedule_new.push(custom_row);
            }
          }

          // ตั้งค่า default interest ถ้ายังไม่มีค่า
          let interest_48 = null;
          let interest_60 = null;
          let interest_72 = null;
          let interest_84 = null;
          let interest_96 = null;

          // ดึงจาก car_down_schedule ถ้ามี
          if (car_down_schedule_new.length > 0) {
            let firstRow = car_down_schedule_new[0];
            interest_48 = firstRow.interest_48 !== undefined ? firstRow.interest_48 : null;
            interest_60 = firstRow.interest_60 !== undefined ? firstRow.interest_60 : null;
            interest_72 = firstRow.interest_72 !== undefined ? firstRow.interest_72 : null;
            interest_84 = firstRow.interest_84 !== undefined ? firstRow.interest_84 : null;
            interest_96 = firstRow.interest_96 !== undefined ? firstRow.interest_96 : null;
          }

          // ถ้ายังเป็น null ให้ดึงค่า default จาก interest_by_period
          if (interest_48 === null) interest_48 = this.getDefaultInterest(interest_by_period, 48);
          if (interest_60 === null) interest_60 = this.getDefaultInterest(interest_by_period, 60);
          if (interest_72 === null) interest_72 = this.getDefaultInterest(interest_by_period, 72);
          if (interest_84 === null) interest_84 = this.getDefaultInterest(interest_by_period, 84);
          if (interest_96 === null) interest_96 = this.getDefaultInterest(interest_by_period, 96);

          if (data.car_down_schedule.length === 0) {
            this.setState({
              lists: car_down_schedule_new,
              carDownPercent: data.car_down_percent,
              car_down_schedule_note: car_down_schedule_note,
              action: "add",
              interest_by_period: interest_by_period,
              interest_type: interest_type,
              interest_48: interest_48,
              interest_60: interest_60,
              interest_72: interest_72,
              interest_84: interest_84,
              interest_96: interest_96,
            }, () => {
              // Recalculate after state is updated with correct interest_type
              if (interest_type === "by_period") {
                this.recalculateAllRows();
              }
            });
          } else {
            this.setState({
              lists: car_down_schedule_new,
              carDownPercent: data.car_down_percent,
              car_down_schedule_note: car_down_schedule_note,
              action: "edit",
              interest_by_period: interest_by_period,
              interest_type: interest_type,
              interest_48: interest_48,
              interest_60: interest_60,
              interest_72: interest_72,
              interest_84: interest_84,
              interest_96: interest_96,
            }, () => {
              // Recalculate after state is updated with correct interest_type
              if (interest_type === "by_period") {
                this.recalculateAllRows();
              }
            });
          }
        }
      })
      .catch((error) => {
        if (this.mounted) {
          this.setState({ lists: [] });
        }
      });
  }

  // Helper function to get default interest from interest_by_period array
  getDefaultInterest(interest_by_period, period_months) {
    if (interest_by_period && interest_by_period.length > 0) {
      let found = interest_by_period.find(
        (item) => item.period_months === period_months
      );
      if (found) {
        return found.interest_rate;
      }
    }
    return 0;
  }

  onPreviewSelected(url) {
    this.setState({
      preview_image_url: url,
      preview_image_select: true,
    });
  }

  togglePreviewImage() {
    this.setState({
      preview_image_select: !this.state.preview_image_select,
    });
  }

  async handleDownloadImage() {
    this.setState(
      {
        is_download: true,
      },
      async () => {
        const element = this.printRef.current;
        //const element = this.downloadRef.current;
        const canvas = await html2canvas(element, {
          letterRendering: 1,
          allowTaint: true,
          useCORS: true,
        });

        const data = canvas.toDataURL("image/jpg");
        const link = document.createElement("a");

        if (typeof link.download === "string") {
          link.href = data;
          link.download = "ตารางราคา.jpg";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(data);
        }

        setTimeout(() => {
          this.setState({ is_download: false });
        }, 1200);
      },
    );
  }

  loadCompanyLogoBase64() {
    let uri = APIURL + "/company_setting/logoimage/1";
    axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ logoBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  loadCompanySetting() {
    axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      this.setState({
        company_name: company_setting.company_name,
        company_tel: company_setting.company_tel,
      });
    });
  }

  async loadCarImageBase64() {
    let car_upload_id = this.props.car.car_upload_id;
    let uri = APIURL + "/car/image/" + car_upload_id;
    await axios
      .get(uri)
      .then((res) => {
        let body = res.data.body;
        this.setState({ carBase64Img: body });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  onChangeInputRow(carDownScheduleSelect, index, event) {
    let car_down_schedule_id = carDownScheduleSelect.car_down_schedule_id;
    let name = event.target.name;
    let value = event.target.value;
    let status_text =
      carDownScheduleSelect.status_text === "new" ? "new" : "edit";

    let list = this.state.lists.map((car) =>
      car.car_down_schedule_id === car_down_schedule_id
        ? { ...car, [name]: value, status_text: status_text }
        : car,
    );

    this.setState({
      lists: list,
    });
  }

  onChangeInputCarDownPrice(carDownScheduleSelect, index, event) {
    let car_down_schedule_id = carDownScheduleSelect.car_down_schedule_id;
    let name = event.target.name;
    let value = event.target.value;
    let is_custom_row = carDownScheduleSelect.car_down_percent_id === 0;
    let status_text =
      carDownScheduleSelect.status_text === "new" ? "new" : "edit";
    let down_schedule_price_update = {
      ...carDownScheduleSelect,
      status_text: status_text,
      car_down_schedule_price: value,
    };

    // คำนวณ % ย้อนกลับสำหรับ custom row (car_down_percent_id === 0)
    if (is_custom_row && value && value !== "" && this.state.car_sale_price) {
      let calculated_percent = this.calculateDownPercent(
        value,
        this.state.car_sale_price,
      );
      down_schedule_price_update.car_down_percent_name =
        calculated_percent + "%";
    }

    let down_schedule_price = this.calCarDownSchedule(
      down_schedule_price_update,
    );

    let list = this.state.lists.map((car) =>
      car.car_down_schedule_id === car_down_schedule_id
        ? down_schedule_price
        : car,
    );

    this.setState({
      lists: list,
    });
  }

  getCarLeasingPrice(down_schedule) {
    let car_sale_price = this.state.car_sale_price;
    let is_show_percent_down = this.state.is_show_percent_down;
    let is_custom_row = down_schedule.is_custom_row || false;

    let car_down_schedule_price_new = NumberUtil.removeComma(
      down_schedule.car_down_schedule_price,
    );
    let car_down_percent_name = down_schedule.car_down_percent_name;
    let car_down_percent = 0;

    // Custom row ใช้ค่าที่กรอกโดยตรง ไม่ต้อง parse % (เพราะ car_down_percent_name อาจเป็น "กำหนดเอง" หรือ "12.5%")
    if (!is_custom_row) {
      car_down_percent = Number(car_down_percent_name.replace("%", ""));
    }

    let car_down_schedule_price = 0;

    // Custom row ใช้ค่าที่กรอกโดยตรง ไม่คำนวณจาก %
    if (is_custom_row || is_show_percent_down === false) {
      car_down_schedule_price = parseFloat(
        String(Number(car_down_schedule_price_new) || 0),
      );
    } else {
      //คำนวณออโต้จาก %
      car_down_schedule_price = parseFloat(
        String((car_sale_price * car_down_percent) / 100),
      );
    }

    let car_leasing_price = car_sale_price - car_down_schedule_price;
    return {
      car_leasing_price,
      car_down_schedule_price,
    };
  }

  calCarDownSchedule(down_schedule) {
    let car_down_interest = down_schedule.car_down_interest;
    let is_custom_row = down_schedule.is_custom_row || false;

    let { car_leasing_price, car_down_schedule_price } =
      this.getCarLeasingPrice(down_schedule);

    let monthly_installment_48,
      monthly_installment_60,
      monthly_installment_72,
      monthly_installment_84,
      monthly_installment_96;

    // For custom rows, only calculate when BOTH price and interest have valid values
    // Otherwise preserve existing values or keep empty
    if (is_custom_row) {
      // For existing custom rows loaded from database, preserve the monthly_installment values
      // Only recalculate for new custom rows or when explicitly requested (edited)
      if (down_schedule.status_text === "exits") {
        // Existing data - preserve monthly_installment values from database
        monthly_installment_48 = down_schedule.monthly_installment_48 || "";
        monthly_installment_60 = down_schedule.monthly_installment_60 || "";
        monthly_installment_72 = down_schedule.monthly_installment_72 || "";
        monthly_installment_84 = down_schedule.monthly_installment_84 || "";
        monthly_installment_96 = down_schedule.monthly_installment_96 || "";
      } else if (car_down_schedule_price && car_down_schedule_price !== "" &&
                 car_down_interest && car_down_interest !== "") {
        // New or edited row with valid values - calculate the monthly installments
        if (this.state.interest_type === "by_period") {
          // ใช้ดอกเบี้ยตามงวด
          let interest_48 = this.getInterestForPeriod(48);
          let interest_60 = this.getInterestForPeriod(60);
          let interest_72 = this.getInterestForPeriod(72);
          let interest_84 = this.getInterestForPeriod(84);
          let interest_96 = this.getInterestForPeriod(96);

          monthly_installment_48 = this.calInstallationMonth(
            car_leasing_price,
            interest_48,
            4,
          );
          monthly_installment_60 = this.calInstallationMonth(
            car_leasing_price,
            interest_60,
            5,
          );
          monthly_installment_72 = this.calInstallationMonth(
            car_leasing_price,
            interest_72,
            6,
          );
          monthly_installment_84 = this.calInstallationMonth(
            car_leasing_price,
            interest_84,
            7,
          );
          monthly_installment_96 = this.calInstallationMonth(
            car_leasing_price,
            interest_96,
            8,
          );
        } else {
          // ใช้ดอกเบี้ยแบบเดิม (by_down) - use single interest rate
          monthly_installment_48 = this.calInstallationMonth(
            car_leasing_price,
            car_down_interest,
            4,
          );
          monthly_installment_60 = this.calInstallationMonth(
            car_leasing_price,
            car_down_interest,
            5,
          );
          monthly_installment_72 = this.calInstallationMonth(
            car_leasing_price,
            car_down_interest,
            6,
          );
          monthly_installment_84 = this.calInstallationMonth(
            car_leasing_price,
            car_down_interest,
            7,
          );
          monthly_installment_96 = this.calInstallationMonth(
            car_leasing_price,
            car_down_interest,
            8,
          );
        }
      } else {
        // One or both fields empty - preserve existing values or keep empty
        monthly_installment_48 = down_schedule.monthly_installment_48 || "";
        monthly_installment_60 = down_schedule.monthly_installment_60 || "";
        monthly_installment_72 = down_schedule.monthly_installment_72 || "";
        monthly_installment_84 = down_schedule.monthly_installment_84 || "";
        monthly_installment_96 = down_schedule.monthly_installment_96 || "";
      }
    } else {
      // ตรวจสอบ interest_type - calculate only for preset rows
      if (this.state.interest_type === "by_period") {
        // ใช้ดอกเบี้ยตามงวด
        let interest_48 = this.getInterestForPeriod(48);
        let interest_60 = this.getInterestForPeriod(60);
        let interest_72 = this.getInterestForPeriod(72);
        let interest_84 = this.getInterestForPeriod(84);
        let interest_96 = this.getInterestForPeriod(96);

        monthly_installment_48 = this.calInstallationMonth(
          car_leasing_price,
          interest_48,
          4,
        );
        monthly_installment_60 = this.calInstallationMonth(
          car_leasing_price,
          interest_60,
          5,
        );
        monthly_installment_72 = this.calInstallationMonth(
          car_leasing_price,
          interest_72,
          6,
        );
        monthly_installment_84 = this.calInstallationMonth(
          car_leasing_price,
          interest_84,
          7,
        );
        monthly_installment_96 = this.calInstallationMonth(
          car_leasing_price,
          interest_96,
          8,
        );
      } else {
        // ใช้ดอกเบี้ยแบบเดิม (by_down)
        monthly_installment_48 = this.calInstallationMonth(
          car_leasing_price,
          car_down_interest,
          4,
        );
        monthly_installment_60 = this.calInstallationMonth(
          car_leasing_price,
          car_down_interest,
          5,
        );
        monthly_installment_72 = this.calInstallationMonth(
          car_leasing_price,
          car_down_interest,
          6,
        );
        monthly_installment_84 = this.calInstallationMonth(
          car_leasing_price,
          car_down_interest,
          7,
        );
        monthly_installment_96 = this.calInstallationMonth(
          car_leasing_price,
          car_down_interest,
          8,
        );
      }
    }

    let down_schedule_new = {
      ...down_schedule,
      is_custom_row: is_custom_row,
      car_down_schedule_price: car_down_schedule_price,
      car_down_interest: car_down_interest,
      car_leasing_price: car_leasing_price,
      monthly_installment_48: monthly_installment_48,
      monthly_installment_60: monthly_installment_60,
      monthly_installment_72: monthly_installment_72,
      monthly_installment_84: monthly_installment_84,
      monthly_installment_96: monthly_installment_96,
    };
    return down_schedule_new;
  }

  onChangeInputCarDownInterest(carDownScheduleSelect, index, event) {
    let car_down_schedule_id = carDownScheduleSelect.car_down_schedule_id;
    let name = event.target.name;
    let value = event.target.value;
    let is_custom_row = carDownScheduleSelect.car_down_percent_id === 0;
    let status_text =
      carDownScheduleSelect.status_text === "new" ? "new" : "edit";
    let down_schedule_update = {
      ...carDownScheduleSelect,
      status_text: status_text,
      car_down_interest: value,
    };

    // สำหรับ custom row ถ้ามีค่าเงินดาวน์อยู่แล้ว ให้คำนวณ % ย้อนกลับ
    if (
      is_custom_row &&
      carDownScheduleSelect.car_down_schedule_price &&
      carDownScheduleSelect.car_down_schedule_price !== "" &&
      this.state.car_sale_price
    ) {
      let calculated_percent = this.calculateDownPercent(
        carDownScheduleSelect.car_down_schedule_price,
        this.state.car_sale_price,
      );
      down_schedule_update.car_down_percent_name = calculated_percent + "%";
    }

    let down_schedule = this.calCarDownSchedule(down_schedule_update);

    let list = this.state.lists.map((car) =>
      car.car_down_schedule_id === car_down_schedule_id ? down_schedule : car,
    );

    this.setState({
      lists: list,
    });
  }

  onInputChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      [name]: value,
    });
  }

  // toggle interest_type
  onToggleInterestType() {
    let new_interest_type =
      this.state.interest_type === "by_down" ? "by_period" : "by_down";
    this.setState({ interest_type: new_interest_type }, () => {
      // recalculate all rows
      this.recalculateAllRows();
    });
  }

  // get interest for specific period (use default from interest_by_period if not set)
  getInterestForPeriod(period_months) {
    let stateKey = "interest_" + period_months;
    let interest = this.state[stateKey];

    // ถ้ามีค่าใน state ให้ใช้ค่านั้น
    if (interest !== null && interest !== undefined && interest !== "") {
      return interest;
    }

    // ถ้าไม่มี ให้ดึงจาก interest_by_period default
    let interest_by_period = this.state.interest_by_period;
    if (interest_by_period && interest_by_period.length > 0) {
      let found = interest_by_period.find(
        (item) => item.period_months === period_months,
      );
      if (found) {
        return found.interest_rate;
      }
    }

    return 0;
  }

  // handle change interest by period
  onChangeInterestByPeriod(period_months, value) {
    let stateKey = "interest_" + period_months;
    this.setState({ [stateKey]: value }, () => {
      // recalculate all rows
      this.recalculateAllRows();
    });
  }

  // recalculate all rows
  recalculateAllRows() {
    let lists = this.state.lists;
    let new_lists = lists.map((row) => this.calCarDownSchedule(row));
    this.setState({ lists: new_lists });
  }

  render() {
    let self = this;

    let is_show_interest = true;
    if (PORT === 9061 || PORT === 9039) {
      is_show_interest = false;
    }

    // ถ้าเป็น by_period และ PORT 9079 ให้ซ่อนช่องดอกเบี้ยในตาราง
    if (PORT === 9079 && this.state.interest_type === "by_period") {
      is_show_interest = false;
    }

    let is_show_percent_down = this.state.is_show_percent_down;

    let image_url = this.state.carBase64Img;
    let logo = this.state.logoBase64Img;
    let car_sale_price = this.state.car_sale_price;

    let logoWidth = 60;

    // กรอง lists: ถ้า is_download === true หรือ interest_type === "by_period" ให้ซ่อน custom row
    let listsForRender = this.state.lists;

    if (this.state.interest_type === "by_period") {
      // 1. ถ้าเป็นโหมด "ดอกเบี้ยตามงวด" ให้ซ่อนแถวกำหนดเองเสมอ
      listsForRender = listsForRender.filter((down_percent) => !down_percent.is_custom_row);
    } else if (this.state.is_download) {
      // 2. ถ้าเป็นโหมด "ดาวน์โหลด" และอยู่ใน "by_down"
      // ให้ซ่อนแถวกำหนดเอง "เฉพาะกรณีที่ยังไม่ได้กรอกราคาเงินดาวน์" เท่านั้น
      listsForRender = listsForRender.filter((down_percent) => {
        if (down_percent.is_custom_row) {
          const price = down_percent.car_down_schedule_price;
          // ถ้าไม่มีการกรอกราคา (ว่าง หรือ 0) ให้ซ่อนในรูปภาพ
          return price !== "" && price !== 0 && price !== null;
        }
        return true; // แถวปกติให้แสดงเสมอ
      });
    }

    /*if (this.state.is_download || this.state.interest_type === "by_period") {
      listsForRender = this.state.lists.filter((down_percent) => {
        /!*return !(
          down_percent.car_down_percent_name === "กำหนดเอง" &&
          down_percent.car_down_schedule_id === "custom"
        );*!/
        return !(
            down_percent.car_down_schedule_id === "custom" ||
            down_percent.is_custom_row === true ||
            down_percent.car_down_percent_id === 0
        );
      });
    }*/

    let trDownScheduleNew = listsForRender.map((down_percent, index) => {
      let car_down_percent_name = down_percent.car_down_percent_name;
      let car_down_schedule_price_input =
        down_percent.car_down_schedule_price || "";
      let is_custom_row = down_percent.is_custom_row || false;

      // สำหรับ custom row หรือกรณี car_down_percent_name ว่าง: คำนวณ % ย้อนกลับ
      let display_percent_name = car_down_percent_name;
      if (
        is_custom_row ||
        car_down_percent_name === "" ||
        car_down_percent_name === null ||
        car_down_percent_name === undefined
      ) {
        if (
          car_down_schedule_price_input &&
          car_down_schedule_price_input !== "" &&
          Number(car_down_schedule_price_input) > 0 &&
          car_sale_price
        ) {
          let calculated_percent = this.calculateDownPercent(
            car_down_schedule_price_input,
            car_sale_price,
          );
          display_percent_name = calculated_percent + "%";
        } else {
          display_percent_name = "กำหนดเอง";
        }
      }

      // สำหรับ non-custom row ถ้ายังไม่มีค่า ให้คำนวณจาก %
      if (
        !is_custom_row &&
        (car_down_schedule_price_input === "" ||
          car_down_schedule_price_input === 0)
      ) {
        let car_down_percent = Number(car_down_percent_name.replace("%", ""));
        car_down_schedule_price_input = parseFloat(
          String((car_sale_price * car_down_percent) / 100),
        ).toFixed(2);
      }

      let input_down = (
        <NumberFormat
          className="form-control text-center"
          thousandSeparator={true}
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          id="car_down_schedule_price"
          name="car_down_schedule_price"
          value={car_down_schedule_price_input}
          onChange={(event) =>
            this.onChangeInputCarDownPrice(down_percent, index, event)
          }
        />
      );

      let input_interest = (
        <NumberFormat
          className="form-control text-center"
          thousandSeparator={true}
          min={0}
          max={1000000000}
          step={1000}
          size={10}
          allowNegative={false}
          id="car_down_interest"
          name="car_down_interest"
          value={down_percent.car_down_interest || ""}
          onChange={(event) =>
            this.onChangeInputCarDownInterest(down_percent, index, event)
          }
        />
      );

      return (
        <tr
          key={index}
          style={
            down_percent.is_custom_row ? { backgroundColor: "#e3f2fd" } : {}
          }
        >
          <td
            style={{ width: 105 }}
            className={is_show_percent_down ? "text-center" : "hidden"}
          >
            <span
              className={
                down_percent.is_custom_row
                  ? "text-primary font-weight-bold"
                  : ""
              }
            >
              {display_percent_name}
            </span>
          </td>
          <td style={{ width: 132 }}>{input_down}</td>
          <td
            style={{ width: 132 }}
            className={is_show_interest ? "" : "hidden"}
          >
            {input_interest}
          </td>
          <td style={{ width: 132 }} className="text-center">
            {down_percent.monthly_installment_48 ? (
              <NumberFormat
                value={down_percent.monthly_installment_48}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              "-"
            )}
          </td>
          <td style={{ width: 132 }} className="text-center">
            {down_percent.monthly_installment_60 ? (
              <NumberFormat
                value={down_percent.monthly_installment_60}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              "-"
            )}
          </td>
          <td style={{ width: 132 }} className="text-center">
            {down_percent.monthly_installment_72 ? (
              <NumberFormat
                value={down_percent.monthly_installment_72}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              "-"
            )}
          </td>
          <td style={{ width: 132 }} className="text-center">
            {down_percent.monthly_installment_84 ? (
              <NumberFormat
                value={down_percent.monthly_installment_84}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              "-"
            )}
          </td>
          <td style={{ width: 132 }} className="text-center">
            {down_percent.monthly_installment_96 ? (
              <NumberFormat
                value={down_percent.monthly_installment_96}
                displayType={"text"}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={true}
              />
            ) : (
              "-"
            )}
          </td>
        </tr>
      );
    });

    // สร้าง header สำหรับ by_period (เฉพาะ PORT 9079)
    let interestByPeriodHeader = null;
    if (PORT === 9079 && this.state.interest_type === "by_period") {
      let interest_by_period = this.state.interest_by_period;
      interestByPeriodHeader = (
        <tr style={{ backgroundColor: "#f5f5f5" }}>
          <td
            colSpan={this.state.interest_type === "by_period" ? 2 : 3}
            className="text-right"
          >
            <strong>ดอกเบี้ย:</strong>
          </td>
          {interest_by_period.map((period, idx) => (
            <td key={idx} style={{ width: 132 }} className="text-center">
              <NumberFormat
                className="form-control text-center"
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale={2}
                allowNegative={false}
                value={
                  this.state["interest_" + period.period_months] ||
                  period.interest_rate
                }
                onValueChange={(values) =>
                  this.onChangeInterestByPeriod(
                    period.period_months,
                    values.value,
                  )
                }
              />
            </td>
          ))}
        </tr>
      );
    }

    // toggle checkbox
    let toggleCheckbox = (
      <div className="row mb-3">
        <div className="col-12 text-right">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="interest_type_toggle"
              checked={this.state.interest_type === "by_period"}
              onChange={() => this.onToggleInterestType()}
            />
            <label className="form-check-label" htmlFor="interest_type_toggle">
              ใช้ดอกเบี้ยตามงวด
            </label>
          </div>
        </div>
      </div>
    );

    return (
      <>
        <div className="card card-accent-info" ref={this.printRef}>
          <form
            action=""
            method="post"
            onSubmit={(event) => {
              // When interest_type is "by_down", set period interest values to null
              const periodInterestValues = this.state.interest_type === "by_period"
                ? {
                    interest_48: this.state.interest_48,
                    interest_60: this.state.interest_60,
                    interest_72: this.state.interest_72,
                    interest_84: this.state.interest_84,
                    interest_96: this.state.interest_96,
                  }
                : {
                    interest_48: null,
                    interest_60: null,
                    interest_72: null,
                    interest_84: null,
                    interest_96: null,
                  };

              this.props.onSubmit(
                event,
                this.state.lists,
                this.state.car_down_schedule_note,
                this.state.interest_type,
                periodInterestValues.interest_48,
                periodInterestValues.interest_60,
                periodInterestValues.interest_72,
                periodInterestValues.interest_84,
                periodInterestValues.interest_96,
              );
            }}
          >
            <div className="card-header text-center">
              <h6>
                <strong>ตารางผ่อน - ดาวน์รถ</strong>
              </h6>
            </div>

            <div className="card-block">
              <div className="text-center">
                <img src={logo} width={logoWidth} alt="logo" />
                <span className="ml-3">
                  {this.state.company_name}&nbsp;&nbsp;{this.state.company_tel}
                </span>
              </div>

              <div className="text-center mt-3 mb-3">
                <img src={image_url} width="600" alt="car" />
              </div>

              <div className="row">
                <div className="col-sm-12 text-center">
                  <h6>
                    <strong className="font-weight-bold">
                      {this.state.car.car_name}&nbsp; สี
                      {this.state.car.car_color_name}
                    </strong>
                  </h6>
                </div>
              </div>

              <div className="row text-center">
                <div className="col-12">
                  <h6>
                    <strong>
                      ราคารถยนต์ : &nbsp;&nbsp;
                      <NumberFormat
                        value={this.state.car_sale_price}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp; บาท
                    </strong>
                  </h6>
                </div>
              </div>

              <hr />

              {this.state.is_download || PORT !== 9079 ? null : toggleCheckbox}

              <div className="row text-center">
                <table className="" style={{ marginTop: 20, marginBottom: 5 }}>
                  <thead>
                    <tr>
                      <th
                        className={
                          is_show_percent_down ? "text-center" : "hidden"
                        }
                      >
                        ดาวน์
                      </th>
                      <th className="text-center">เงินดาวน์</th>
                      <th
                        className={is_show_interest ? "text-center" : "hidden"}
                      >
                        ดอกเบี้ย %{" "}
                      </th>
                      <th className="text-center">48 เดือน</th>
                      <th className="text-center">60 เดือน</th>
                      <th className="text-center">72 เดือน</th>
                      <th className="text-center">84 เดือน</th>
                      <th className="text-center">96 เดือน</th>
                    </tr>
                    {interestByPeriodHeader}
                  </thead>
                  <tbody>{trDownScheduleNew}</tbody>
                </table>
              </div>
              <div className="row mt-4">
                <div className="form-group col-2 text-center">
                  <strong>หมายเหตุ :</strong>
                </div>

                <div className="form-group col-9">
                  <input
                    type="text"
                    className="form-control"
                    id="car_down_schedule_note"
                    name="car_down_schedule_note"
                    value={this.state.car_down_schedule_note || ""}
                    onChange={(e) => {
                      this.setState({
                        car_down_schedule_note: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="card-footer text-right">
              <button
                type="reset"
                onClick={this.props.onHandle.cancel}
                className={
                  this.state.is_download === false
                    ? "btn btn-sm btn-danger mr-2"
                    : "hidden"
                }
                style={{ width: 80 }}
                disabled={this.state.is_submitting}
              >
                <i className="fa fa-refresh" /> ปิด
              </button>

              <button
                type="submit"
                className={
                  this.state.is_download === true
                    ? "hidden"
                    : this.state.action === "add"
                      ? "btn btn-sm btn-primary"
                      : "btn btn-sm btn-warning"
                }
                style={{ width: 100 }}
                disabled={this.state.is_submitting}
              >
                <i
                  className={
                    this.state.is_submitting
                      ? "fa fa-spinner fa-spin"
                      : "fa fa-save"
                  }
                />
                {this.state.is_submitting
                  ? " กำลังบันทึก..."
                  : this.state.action === "add"
                    ? " บันทึก"
                    : " แก้ไข"}
              </button>

              <input
                type="hidden"
                name="action"
                defaultValue={this.state.action}
              />
            </div>
          </form>
        </div>

        <div>
          <button
            className="float-right mb-5 btn btn-secondary"
            type="button"
            onClick={() => this.handleDownloadImage()}
          >
            ดาวน์โหลดตารางผ่อน - ดาวน์รถ.jpg
          </button>
        </div>
      </>
    );
  }
}
